import { defineModule } from '@/app/router/defineModule.ts';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import enforceTwoFactor from '@/app/router/middleware/enforceTwoFactor.js';
import ensureUserIsVerified from '@/app/router/middleware/ensureUserIsVerified.js';

export default defineModule({
    name: 'dashboard',
    routes: [
        {
            path: '/',
            name: 'dashboard',
            component: () => import('#modules/dashboard/pages/index.vue'),
            meta: {
                layout: 'app',
                middleware: [shouldBeAuthenticated, enforceTwoFactor, ensureUserIsVerified],
            },
        },
    ],
});
